"use client";

import { useTranslations, useLocale } from "next-intl";
import React, { type ReactElement } from "react";
import {
  HomeSectionHeader,
  HomeFeaturedDevices,
  HomeFeaturedSites,
} from "@/components";
import { useAtomValue } from "jotai";
import { featuredTagAtom } from "@/store/home";
import { cn } from "@oreme/ui";
import { cva } from "class-variance-authority";

const sectionFeaturedVariants = cva("bg-accent");

function HomeSectionFeatured(): ReactElement | null {
  const t = useTranslations("home.SectionFeatured");
  const locale = useLocale();
  const featuredTag = useAtomValue(featuredTagAtom);

  if (!featuredTag) return null;

  const title = t("title", { tag: featuredTag.name[locale] });

  return (
    <section className={cn(sectionFeaturedVariants())}>
      <div className="relative flex flex-col py-12 max-w-screen-2xl mx-auto">
        <HomeSectionHeader title={title} lead={t("lead")} />
        <div className="relative px-4 flex flex-col gap-8">
          <div className="text-center max-w-3xl px-8 mx-auto leading-tight">
            {featuredTag.description[locale]}
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <HomeFeaturedDevices />
            <HomeFeaturedSites />
          </div>
        </div>
      </div>
    </section>
  );
}

export { HomeSectionFeatured };
